const { isValid, parse } = require('date-fns')

function safeDateParser (date) {
  if (typeof date !== 'string') {
    return date
  }

  // try direct parse first (e.g., yyyy-mm-dd)
  const directParse = parse(date)
  if (isValid(directParse)) {
    return directParse
  }

  // handle dd/mm/yyyy or dd-mm-yyyy
  const normalized = date.replace(/[./]/g, '-')
  const parts = normalized.split('-')

  if (parts.length !== 3 || parts.some(p => isNaN(p))) {
    return date
  }

  // pad to handle 1-digit day/month
  let [p1, p2, p3] = parts.map(p => p.padStart(2, '0'))

  if (p3.length !== 4 || p1.length > 2 || p2.length > 2) {
    return date
  }

  const isoFormattedDate = `${p3}-${p2}-${p1}` // yyyy-mm-dd
  const parsed = parse(isoFormattedDate)

  // validate parsed date matches original input components
  if (
    isValid(parsed) &&
    parsed.getDate() === parseInt(p1, 10) &&
    parsed.getMonth() + 1 === parseInt(p2, 10) &&
    parsed.getFullYear() === parseInt(p3, 10)
  ) {
    return isoFormattedDate
  }
  return date
}

module.exports = {
  safeDateParser
}
